import StateContext from '../../contexts/StateContext';
import React, { useContext, useState, useEffect } from 'react';
import { useAtom } from 'jotai';
import { permissionsAtom } from '../../store/media.js';
// import ErrorNotification from './Errors/ErrorNotification.jsx';
import useMediaCoreContext from '../MediaCoreProvider/useMediaCoreContext/useMediaCoreContext.js';
import WorkingCheckmark from '../../../images/icons/working-checkmark.svg';
import HardwareSetup from '../GreenRoom/HardwareSetup';
import RequestPermissionsButton from '../GreenRoom/RequestPermissionsButton';

function HardwareTestApp(props) {
	const state = useContext(StateContext);
	const { mediaStream, onPermissionsRequest, onDeviceChange, hasPermission } = useMediaCoreContext();
	const [permissions, setPermissions] = useAtom(permissionsAtom);
	const constraints = {};
	const hasAnyPermissions =
		hasPermission ||
		permissions.audioOnly ||
		permissions.acceptNoDevices ||
		permissions.microphone ||
		permissions.camera;

	window.ad = state.activeDevices;
	window.constraints = constraints;
	const [isSuccess, setIsSuccess] = useState(false);
	useEffect(() => {
		if (!props.testType) {
			return;
		}
		setIsSuccess(mediaStream?.active);
	}, [mediaStream?.active]);
	return (
		<div className="hw-test" style={{ position: 'relative' }}>
			<style>{hwTestCss}</style>
			{!hasAnyPermissions ? (
				<div style={{ marginTop: 110 }}>
					<RequestPermissionsButton
						onPermissionsRequest={onPermissionsRequest}
						hasPermission={hasAnyPermissions}
						enabled={props.enabled}
					/>
				</div>
			) : (
				<HardwareSetup
					mediaStream={mediaStream}
					name={props.name}
					// setConstraints={setConstraints}
					onDeviceChange={onDeviceChange}
					onPermissionsRequest={onPermissionsRequest}
					constraints={constraints}
					className={'w-1/4'}
					hasPermission={hasAnyPermissions}
					isInsideGreenRoom
					hiddenSelectors={props.hiddenSelectors}
				/>
			)}
			{isSuccess && (
				<div style={successBannerStyle}>
					<span style={{ marginRight: 5 }}>
						<WorkingCheckmark />
					</span>{' '}
					Your {props.testType} is working
				</div>
			)}

			{/*{!state.settingsDialogOpen.isOpen && (*/}
			{/*	<ErrorNotification error={state.error} onPermissionsRequest={onPermissionsRequest} modal={true} />*/}
			{/*)}*/}
		</div>
	);
}

export default HardwareTestApp;

const successBannerStyle = {
	position: 'absolute',
	background: '#2DAF63',
	width: 'calc(100% - 32px)',
	left: 16,
	bottom: 75,
	textAlign: 'center',
	color: 'white',
	padding: 4,
	fontSize: 13,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

const hwTestCss = `
    .hw-test video {
        max-height: 150 !important;
    }
    .hw-test .h-52 {
        max-height: 204 !important;
    }
`;
